import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Users, Database, Puzzle, ArrowRight } from 'lucide-react';

// Mock data - replace with actual API calls
const mockCounts = {
  coreItems: 128,
  users: 42,
  adapters: 15
};

const AdminLanding = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState(mockCounts);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Replace with actual API call to fetch counts
    const fetchCounts = async () => {
      try {
        // const response = await fetch('/api/admin/counts');
        // const data = await response.json();
        // setCounts(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching counts:', error);
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  const statCards = [
    {
      title: 'Core Items',
      icon: <Database className="w-6 h-6" />,
      description: 'Tools, agents, playbooks, and prompts',
      route: '/studio/admin/core-items',
      gradient: 'from-blue-500 to-blue-600',
      bg: 'bg-blue-50',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      title: 'Users',
      icon: <Users className="w-6 h-6" />,
      description: 'Manage user accounts and permissions',
      route: '/studio/admin/users',
      gradient: 'from-green-500 to-green-600',
      bg: 'bg-green-50',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      title: 'Adapters',
      icon: <Puzzle className="w-6 h-6" />,
      description: 'Manage and configure system adapters',
      route: '/studio/admin/adapters',
      gradient: 'from-purple-500 to-purple-600',
      bg: 'bg-purple-50',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600'
    }
  ];

  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
        <p className="text-gray-600">Overview and quick actions for system administration</p>
      </div>
      
      {/* Action Cards */}
      <div className="grid md:grid-cols-3 gap-6">
        {statCards.map((card, index) => (
          <Card 
            key={index} 
            className="group hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden"
          >
            <div className={`h-2 bg-gradient-to-r ${card.gradient}`}></div>
            <CardContent className="p-6">
              <div className="flex flex-col h-full">
                <div className="flex-1">
                  <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg mb-4 ${card.iconBg} ${card.iconColor}`}>
                    {card.icon}
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">{card.title}</h2>
                  <p className="text-gray-600 mb-6">{card.description}</p>
                </div>
                <Button 
                  variant="outline" 
                  className="w-full group-hover:bg-gray-50 transition-colors flex items-center justify-between"
                  onClick={() => navigate(card.route)}
                >
                  <span>Manage {card.title}</span>
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminLanding;